"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicationProvider = void 0;
const common_1 = require("../../utils/common");
const publicationService_1 = require("../publicationService");
class PublicationProvider {
    /**
     * Initializes PublicationProvider.
     * @param apiClient Api client.
     * @param publicationApi Publication endpoint.
     * @param toolCode Prefered tool. If not set, first tool will be used for work.
     */
    constructor(apiClient, publicationApi, toolCode, publication) {
        this.loadPublication = () => this.apiClient.callApi('GET', this.publicationApi)
            .then(this.setPublication)
            .then(this.setTool);
        this.getExtensionValue = (...navigation) => publicationService_1.PublicationService.getExtensionValue(this.tool.extension, ...navigation);
        this.getExtensionValueWithCulture = (culture, ...navigation) => publicationService_1.PublicationService.getExtensionValueWithCulture(this.tool.extension, culture, ...navigation);
        this.getExtensionValueBoolean = (...navigation) => publicationService_1.PublicationService.getExtensionValueBoolean(this.tool.extension, ...navigation);
        this.getExtensionValueFloat = (...navigation) => publicationService_1.PublicationService.getExtensionValueFloat(this.tool.extension, ...navigation);
        this.getExtensionValueInt = (...navigation) => publicationService_1.PublicationService.getExtensionValueInt(this.tool.extension, ...navigation);
        this.setPublication = (importerPublication) => this._publication = importerPublication;
        this.setTool = (importerPublication) => this._tool = (0, common_1.notNullOrEmpty)(this.toolCode)
            ? importerPublication.importer.tools.find(tool => tool.code === this.toolCode)
            : importerPublication.importer.tools[0];
        this.getWithNullcheck = (property) => {
            if (!property)
                throw new Error('Publication is not loaded. Provide publication in constructor or use loadPublication method.');
            return property;
        };
        this.apiClient = apiClient;
        this.publicationApi = publicationApi;
        this.toolCode = toolCode;
        if (publication) {
            this.setPublication(publication);
            this.setTool(publication);
        }
    }
    get publication() {
        return this.getWithNullcheck(this._publication);
    }
    get tool() {
        return this.getWithNullcheck(this._tool);
    }
}
exports.PublicationProvider = PublicationProvider;
